<div class="tooltip-header">{{ date }}</div>
<div class="tooltip-content" *ngIf="employeesUnavailabilitySorted && employeesUnavailabilitySorted.length">
  <div class="unavailability-row" *ngFor="let employeeUnavailable of employeesUnavailabilitySorted">
    {{ employeeUnavailable.employee.firstName }} {{ employeeUnavailable.employee.lastName }}
    <span class="separator">|</span>
    {{ employeeUnavailable.reason }}
    <span class="separator" *ngIf="employeeUnavailable.shiftCode">|</span>
    <span>{{ employeeUnavailable.shiftCode }}</span>
  </div>
</div>